import { createSlice } from "@reduxjs/toolkit";

import type { ResultsReduxState } from "@app/types/results-redux-types";
import type { SearchInfo } from "@app/types/search-types";

import type { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

// TODO: fix typing
const init_state: ResultsReduxState["search"] = {} as SearchInfo;

const updateSearchReducer: CaseReducer<
  SearchInfo,
  PayloadAction<Partial<SearchInfo>>
> = (state, action) => {
  return { ...state, ...action.payload };
};

const Search = createSlice({
  name: "search",
  initialState: init_state,
  reducers: { updateSearch: updateSearchReducer }
});

export const { updateSearch } = Search.actions;
export default Search.reducer;
